import { createBrowserRouter } from 'react-router-dom';
import { EntryPath } from '@/Config/app/router/entry.path';
import { routes as appRoutes } from '@/Config/app/router/index.router';
import { AuthCallbackPage } from '@/Domain/components/App/AuthCallbackPage';
import { AuthGate } from '@/Domain/components/App/AuthGate';
import EntryLayout from '@/Domain/components/App/Layout/EntryLayout';
import { SessionExpiredRedirect } from '@/Domain/components/App/SessionExpiredRedirect';
import EmailVerificationPage from '@/UI/Auth/EmailVerification.page';
import ForgotPasswordPage from '@/UI/Auth/ForgotPassword.page';
import LoginPage from '@/UI/Auth/Login.page';
import PasskeySetupPage from '@/UI/Auth/PasskeySetup.page';
import RegisterPage from '@/UI/Auth/Register.page';
import ResetPasswordPage from '@/UI/Auth/ResetPassword.page';

const entryRoutes = [
  {
    element: <EntryLayout />,
    children: [
      { index: true, element: <LoginPage /> },
      { path: EntryPath.forgetPassword, element: <ForgotPasswordPage /> },
      { path: EntryPath.register, element: <RegisterPage /> },
      { path: EntryPath.emailVerification, element: <EmailVerificationPage /> },
      { path: EntryPath.resetPassword, element: <ResetPasswordPage /> },
      { path: EntryPath.passkeySetup, element: <PasskeySetupPage /> },
    ],
  },
  { path: '*', element: <SessionExpiredRedirect /> },
];

export const mainRouter = createBrowserRouter([
  { path: '/auth/callback', element: <AuthCallbackPage /> },
  {
    path: '/',
    element: <AuthGate />,
    children: [...entryRoutes, { path: 'i', children: [...appRoutes] }],
  },
]);
